/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./accountSelector.vue?vue&type=template&id=1853c450&scoped=true"
import script from "./accountSelector.vue?vue&type=script&lang=js"
export * from "./accountSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1853c450",
  null
  
)

export default component.exports